var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3059 25.5593L27.5232 29.66C26.6346 29.9693 26.0812 30.8567 26.1952 31.7913L28.0806 47.2493C28.1586 47.8913 28.5426 48.4553 29.1106 48.7647L39.0106 54.146C39.6086 54.4707 40.3306 54.4693 40.9272 54.1427L50.8952 48.6793C51.4599 48.37 51.8412 47.8067 51.9192 47.1673L53.8032 31.718C53.9179 30.778 53.3579 29.8867 52.4612 29.582L40.6066 25.5547C40.1846 25.4113 39.7266 25.4127 39.3059 25.5593Z",
    fill: "url(#paint0_linear_156_126)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4134 32.0933L50.64 46.6667C50.5867 47.0933 50.3334 47.4667 49.9534 47.6733L40.6267 52.6667C40.4267 52.7733 40.2134 52.82 40 52.82C39.9667 52.82 39.94 52.8133 39.9067 52.8133C39.7267 52.8067 39.5467 52.76 39.3734 52.6667L30.0467 47.76C29.6734 47.5533 29.4134 47.1733 29.36 46.7467L27.5867 32.16C27.5067 31.54 27.88 30.9467 28.4667 30.74L39.5467 26.8267C39.6667 26.7867 39.7867 26.76 39.9067 26.76C39.94 26.7533 39.9667 26.7533 40 26.7533C40.1467 26.7533 40.2934 26.78 40.44 26.8267C41.4934 27.2067 44.5734 28.3133 51.52 30.6667C52.1134 30.8733 52.4934 31.4667 52.4134 32.0933Z",
    fill: "url(#paint1_linear_156_126)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.342 46.6667H34.2814L40 34.336V27.9973L31.342 46.6667Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40H40V42.6667H36V40Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4133 32.0933L50.64 46.6667C50.5867 47.0933 50.3333 47.4667 49.9533 47.6733L40.6267 52.6667C40.4267 52.7733 40.2133 52.82 40 52.82V26.7533C40.1467 26.7533 40.2933 26.78 40.44 26.8267C41.4933 27.2067 44.5733 28.3133 51.52 30.6667C52.1133 30.8733 52.4933 31.4667 52.4133 32.0933Z",
    fill: "#B31523"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 28V34.3387L45.7187 46.6693H48.658L40 28Z",
    fill: "#BFC8D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40 40.0027H44V42.6693H40V40.0027Z",
    fill: "#BFC8D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M40.0001 27.9973V28L48.6581 46.6693H45.7188L43.8634 42.6693H40.0001V42.6667H36.1368L34.2814 46.6667H31.3421L40.0001 27.9973ZM37.3734 40H40.0001V40.0027H42.6268L40.0001 34.3387V34.336L37.3734 40ZM40.6668 24.978L39.3954 27.7167L30.7374 46.386L30.2981 47.3333H31.3421H34.2814H34.7074L34.8868 46.9473L36.5621 43.3333H39.3334L40.0001 43.336H43.4381L45.1141 46.95L45.2934 47.336H45.7194H48.6588H49.7028L49.2634 46.3887L40.6668 27.8527V24.978ZM38.4174 39.3333L39.9994 35.922L41.5828 39.336H40.6668L40.0001 39.3333H38.4174Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M40.0001 27.9973V28L48.6581 46.6693H45.7187L43.8634 42.6693H40.0001V42.6667H36.1367L34.2814 46.6667H31.3421L40.0001 27.9973ZM37.3734 40H40.0001V40.0027H42.6267L40.0001 34.3387V34.336L37.3734 40ZM40.3334 26.4887L39.6974 27.8567L31.0394 46.5267L30.8201 47H31.3421H34.2814H34.4941L34.5834 46.8067L36.3487 43H39.6667L40.0001 43.0027H43.6507L45.4161 46.8093L45.5054 47.0027H45.7181H48.6574H49.1794L48.9601 46.5293L40.3334 27.9267V26.4887ZM37.8954 39.6667L39.9994 35.1293L42.1047 39.6693H40.3334L40.0001 39.6667H37.8954Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_156_126",
    x1: 36.9126,
    y1: 28.1707,
    x2: 45.9432,
    y2: 52.9813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#D6E0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC8D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_156_126",
    x1: 40,
    y1: 25.4347,
    x2: 40,
    y2: 50.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.9e80c0e817f30e2b86c005e961a1386a.svg";
export { ForwardRef as ReactComponent };